import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/app/src/app/services/ki-digitalisierung-mittelstand/components/KursClient.tsx");
